export default __webpack_public_path__ + "static/media/dribbble.ba12c6fc.svg";